import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import BackButton from "shared-anpost-components/components/backButton";
import Loader from "shared-anpost-components/components/loader/Loader";
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";

import { Box, Text, Tag, Img } from "../ui";
import { getSearchParamsFromUrl, formatedPrice, formatedDate, mapStatusTagStyles, formatOrderNumber } from "./utils";
import LetterIcon from "../../../../images/letter.svg";
import appHook from "../../../../hooks/appHook";
import { getJWTInfo, getShopOrder } from "../../../../services/Api";

const ShopOrderDetails = () => {
    const [apiError, setApiError] = useState(false);
    const [orderData, setOrderData] = useState(null);
    const [tagStyle, setTagStyle] = useState({});
    const history = useHistory();
    const pageToReturn = getSearchParamsFromUrl("page");
    const { removeNavMargins } = appHook();

    const handleBackCta = () => {
        switch (pageToReturn) {
            case "shop-homepage":
                return {
                    linkUrlFn: () => {
                        window.location.href = "/Shop";
                    },
                    label: "Back to shop"
                };
            case "transactions-history":
                return {
                    linkUrlFn: () => history.push("/Transactions?product=shop"),
                    label: "Back to transactions"
                };
            case "overview":
                return {
                    linkUrlFn: () => history.push("/"),
                    label: "Back to overview"
                };
            default:
                return {
                    linkUrlFn: () => history.goBack(),
                    label: "Back"
                };
        }
    };

    const getOrderDetails = orderId => {
        getJWTInfo().then(() => {
            getShopOrder(orderId)
                .then(res => {
                    if (res.data?.order) {
                        setOrderData(res.data.order);
                    } else if (res?.error?.contains("not be found")) {
                        setOrderData([]);
                    } else setApiError(true);
                })
                .catch(() => {
                    setApiError(true);
                });
        });
    };

    useEffect(() => {
        if (orderData?.orderStatus) {
            setTagStyle(mapStatusTagStyles(orderData.orderStatus));
        }
    }, [orderData]);

    useEffect(() => {
        const orderIdFromUrlParam = getSearchParamsFromUrl("orderId");
        removeNavMargins();
        getOrderDetails(orderIdFromUrlParam);
    }, []);

    if (!orderData && !apiError) return <Loader local />;
    if (apiError) return <GlobalError closeFunc={handleBackCta().linkUrlFn} />;
    if (orderData?.length === 0)
        return (
            <div className="grid-container">
                <p>No order data</p>
            </div>
        );
    if (orderData) {
        return (
            <div className="grid-container">
                <BackButton onClick={handleBackCta().linkUrlFn}>{handleBackCta().label}</BackButton>
                <Text as="h1" fontSize={["2.2rem", "3rem"]} lineHeight="3.6rem" marginTop={[0, "2.4rem"]} marginBottom={["2.4rem", "3.2rem"]}>
                    Order details
                </Text>
                <Box marginBottom={["2.4rem", "3.2rem"]}>
                    {/* not in scope of shop R1 */}
                    {/* <Text fontSize="1.2rem" display="flex" justifyContent={["flex-start", "flex-end"]} marginBottom={["0.8rem", "1.6rem"]}>
                        Prices displayed exclude VAT
                    </Text> */}
                    <Box padding={["2.4rem", "3.2rem"]} border="1px solid #CFD0CF" borderRadius="0.5rem" flexDirection={["column", "row"]} gap={["1.6rem", "5.6rem"]}>
                        <div style={{ flex: 1 }}>
                            <Box flexDirection={["column", "row"]} gap={["0.8rem", "3.2rem"]} marginBottom="1.6rem">
                                <Text fontSize="2.2rem" fontWeight={700} fontFamily="AnPostSansBold">
                                    {formatedDate(orderData.orderDate)} | Shop
                                </Text>
                                <Text fontSize="1.4rem">
                                    Order reference: <strong style={{ fontSize: "1.4rem" }}>{formatOrderNumber(orderData.orderId)}</strong>
                                </Text>
                            </Box>
                            <Tag backgroundColor={tagStyle.backgroundColor} dotColor={tagStyle.dotColor}>
                                {orderData.orderStatus}
                            </Tag>
                            <hr style={{ borderTop: "1px solid #CFD0CF" }} />
                            <Box gap="0.8rem" marginBottom={["2.4rem", "1.6rem"]}>
                                <Text fontSize={["1.4rem", "1.6rem"]}>
                                    Number of items: <strong>{orderData.orderItems.length}</strong>
                                </Text>
                                <Text fontSize={["1.4rem", "1.6rem"]}>
                                    Shipping costs: <strong>{formatedPrice(orderData.shippingCost)}</strong>
                                </Text>
                                {orderData.discountApplied > 0 && (
                                    <Text fontSize={["1.4rem", "1.6rem"]}>
                                        Discount applied: <strong style={{ color: "#D22630" }}>-{formatedPrice(orderData.discountApplied)}</strong>
                                    </Text>
                                )}
                            </Box>
                            <Box flexDirection={["column", "row"]} alignItems={["flex-start", "center"]} gap={["1.6rem", "2.4rem"]}>
                                <Text as="span" backgroundColor="#F3F3F3" padding={["0.8rem 1.6rem", "1.6rem"]} fontSize={["1.6rem", "1.8rem"]} fontFamily="AnPostSansBold">
                                    {formatedPrice(orderData.orderTotal)}
                                </Text>
                                {orderData.registeredPost && (
                                    <Text fontSize="1.2rem" display="flex" gap="0.8rem" alignItems="center">
                                        Service: Registered post
                                        <Img src={LetterIcon} style={{ margin: 0 }} />
                                    </Text>
                                )}
                            </Box>
                        </div>
                        {/* not in scope of shop R1 */}
                        {/* <Box>
                            <button className="bn bn--primary" style={{ marginBottom: "1.6rem" }}>
                                Order again
                            </button>
                            {orderData.registeredPost && (
                                <button className="bn bn--secondary-b" style={{ marginBottom: "1.6rem" }}>
                                    Track
                                </button>
                            )}
                            <Text
                                as="a"
                                marginTop={[0, "auto"]}
                                justifyContent="center"
                                fontSize={["1.4rem", "1.6rem"]}
                                color="#008755"
                                fontFamily="AnPostSansBold"
                                display="flex"
                                alignItems="center"
                                gap="0.8rem"
                            >
                                <Img src={DownloadIcon} style={{ margin: 0 }} />
                                Download invoice
                            </Text>
                        </Box> */}
                    </Box>
                </Box>
                <Box gap={["2.4rem", "1.6rem"]} marginBottom={["4rem", "8rem"]}>
                    {orderData.orderItems.map((orderItem, i) => (
                        <Box flexDirection={["column", "row"]} padding={["2.4rem 1.6rem", "3rem"]} border="1px solid #CFD0CF" borderRadius="0.5rem" key={i}>
                            {orderItem.imagePath ? (
                                <Img
                                    width="100%"
                                    height="100%"
                                    maxHeight={["13rem", "20.4rem"]}
                                    maxWidth="29rem"
                                    margin="auto"
                                    objectFit="contain"
                                    marginBottom={["2.4rem", "auto"]}
                                    src={orderItem.imagePath.replace("~", "")}
                                ></Img>
                            ) : (
                                <Box width="100%" height="100%" maxWidth="29rem" />
                            )}
                            <Box marginLeft={[0, "3.2rem"]} width="100%">
                                <Text fontSize={["2.2rem", "2.6rem"]} fontWeight={700} fontFamily="AnPostSansBold">
                                    {orderItem.productName}
                                </Text>
                                <hr style={{ borderTop: "1px solid #CFD0CF" }} />
                                <Text fontSize={["1.4rem", "1.6rem"]} marginBottom={["1.6rem", "3.2rem"]}>
                                    Quantity: <strong>{orderItem.quantity}</strong>
                                </Text>
                                <Box alignItems="center" flexDirection="row">
                                    <Text as="span" backgroundColor="#F3F3F3" padding={["1.2rem 1.6rem", "1.6rem"]} fontSize={["1.8rem", "2rem"]} fontFamily="AnPostSansBold">
                                        {formatedPrice(orderItem.productPrice)}
                                    </Text>
                                    {orderItem.itemHasDiscount && (
                                        <Text as="span" backgroundColor="#217BBE" transform="skew(-10deg)" padding="0.2rem 1rem" borderRadius="0.4rem" marginLeft={["1.6rem", "2.4rem"]}>
                                            <Text as="span" fontSize="1.4rem" fontFamily="AnPostSansBold" color="#fff" transform="skew(10deg)">
                                                Discount
                                            </Text>
                                        </Text>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </div>
        );
    }
};

export default ShopOrderDetails;
